import { FIXED_MEMBERSHIP, HOURLY_MEMBERSHIP, HYBRID_MEMBERSHIP, PERCENTAGE_MEMBERSHIP, REDEEMABLES_TYPES } from "@constant/common";
import { disableLoader, enableLoader, showError, showSuccess } from "@context/actions";
import { Backdrop } from "@material-ui/core";
import PaymentVendorModal from "@module/paymentVendorModal";
import UserRegistrationModal from "@module/userRegistration";
import { loadStripe, Stripe, StripeElementsOptionsClientSecret } from '@stripe/stripe-js';
import StripePaymentModal from "@template/stripe/StripePaymentModal";
import { APISERVICE } from "@util/apiService/RestClient";
import { getCurrencySymbol, getDateObj, hasPaymentGateway } from "@util/utils";
import { windowRef } from "@util/window";
import { useRouter } from 'next/router';
import Script from "next/script";
import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { CloseIcon, IconFrame } from '@element/icons';


function RedeemableItemModal({ type, item, onClose }) {
    const router = useRouter();
    const state = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const isMembership = type == REDEEMABLES_TYPES.MEMBERSHIPS;
    const isPackage = type == REDEEMABLES_TYPES.PACKAGES;
    const isGiftCard = type == REDEEMABLES_TYPES.GIFTCARDS;
    const { configData, keywords } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const [cookie, setCookie] = useCookies();
    const [userData, setUserData] = useState(cookie['user']);
    const [showUserRegistrationModal, setShowUserRegistrationModal] = useState(false)
    const modalRef = useRef(null);
    const storeData = useSelector((state: any) => state.store.storeData);
    const storeMetaData = useSelector((state: any) => state.store ? state.store.storeMetaData : null);
    const languageData: any = state.languageKeywords
    const uniqueRecordIdentifier = new Date().getTime()
    const [openPaymentVendorModal, setOpenPaymentVendorModal] = useState<string>('');
    const [paymentGatewayList, setPaymentGatwayList] = useState<any[]>([]);
    const [txchrgs, setTxchrgs] = useState([]);
    const [taxesTotal, setTaxesTotal] = useState(0);
    const [selectedItems, setSelectedItems] = useState<any>({ product: [], service: [] });
    const purchaseConfig = configData?.storeConfig?.sparkConfig?.purchaseConfig ?? {};
    const purchaseKey = `${type.slice(0, -1)}Purchase`;
    const allowPurchase = Boolean(purchaseConfig?.[purchaseKey]) && Boolean(paymentGatewayList?.length);
    interface StripeValues {
        options: StripeElementsOptionsClientSecret;
        promise: Promise<Stripe>;
        paymentIntentId: string;
        redirectUrl: any,
        order?: any,
        address?: any,
        user?: any,
        callbackUrl?: any
    }
    const [stripeModalDetails, setStripeModalDetails] = useState<StripeValues>({
        options: {
            clientSecret: "",
            appearance: {
                theme: 'stripe',
                labels: 'floating',
            }
        },
        promise: undefined,
        paymentIntentId: "",
        redirectUrl: "",
        callbackUrl: "",
    });

    const [globalPaymentsModalDetails, setGlobalPaymentsModalDetails] = useState<any>({
        accessToken: "",
        reference: ""
    });

    router?.events?.on('routeChangeStart', (newRoute) => {
        if (!newRoute.includes('-pdp')) {//if on browser back click remove pdp element// here check is added because we cant get previous url 
            closePdpModal()
        }
    });

    let displayPrice = 0;
    if (item) {
        if (isMembership) displayPrice = item.membershipFee;
        else if (isPackage) displayPrice = item.price;
        else if (isGiftCard) displayPrice = item.giftCardValue;
    }

    useEffect(() => {
        if (!item) return;
        if (isMembership) {
            calculateTaxes(item)
        } else if (isPackage) {
            const selectedItemsCopy: any = { service: [], product: [] };
            const types = ['product', 'service'];

            types.map((type: any) => {
                item.packageItems.filter((i: any) => i.type == type).map((i: any) => selectedItemsCopy[type].push({
                    category: i.category,
                    categoryId: i.categoryId,
                    packageItemId: i.id,
                    id: i.itemId,
                    name: i.itemName,
                    quantity: i.quantity,
                    variationId: i.variationId,
                    variation: i.variationName,
                    type: i.type,
                    price: i.itemPrice,
                    hsnSac: i.hsnSac
                }))
            })
            setSelectedItems({ ...selectedItemsCopy });
            if (Boolean(item?.txchrgs?.length)) {
                calculateTaxes(item);
            }
        }

        APISERVICE.GET(process.env.NEXT_PUBLIC_PAYMENT_VENDOR + `?tenantId=${storeData.tenantId}&storeId=${storeData.storeId}`)
            .then((resp) => {
                if (!resp.data) {
                    console.error("Unable to load payment configurations")
                    return;
                }
                setPaymentGatwayList(resp.data.data);
                const stripePaymode = resp.data.data?.find((paymode) => paymode.name == "Stripe");
                if (stripePaymode) {
                    setStripeModalDetails({ ...stripeModalDetails, ...stripePaymode, promise: loadStripe(stripePaymode.key) })
                }
            }).catch((err) => {
                console.error(err)
            })
    }, [item]);

    useEffect(() => {
        if (cookie['user']) {
            setUserData(cookie['user'])
        }
    }, [cookie])

    useEffect(() => {
        if (windowRef && item) {
            APISERVICE.GET(process.env.NEXT_PUBLIC_PAYMENT_VENDOR + `?tenantId=${storeData.tenantId}&storeId=${storeData.storeId}`)
                .then((resp) => {
                    if (!resp.data) {
                        console.error("Unable to load payment configurations")
                        return;
                    }
                    setPaymentGatwayList(resp.data.data);

                }).catch((err) => {
                    console.error(err)
                })

            setTimeout(() => {
                if (item) {
                    document.body.classList.add("o-h")
                } else {
                    closePdpModal()
                }
            }, 0);
        }
    }, [item, windowRef]);


    const buildMembershipTxnObj = ({
        membership,
        userDetails,
        payments,
        uniqueRecordIdentifier,
        sourceRemark = 'Purchase from PDP'
    }) => {
        const currentDate = getDateObj();

        const benifitedAmt =
            membership.typeId === 1 || membership.typeId === 5
                ? Number(membership.membershipFee) + Number(membership.benefit)
                : 0;

        const someDate = new Date(currentDate.dateObj);
        const toDate = new Date(someDate.setDate(someDate.getDate() + Number(membership.validity)))
        return {
            active: true,
            balanceAmount: benifitedAmt,
            benefitAmount: membership.typeId === 1 ? membership.benefit : 0,

            createdOn: new Date(),
            modifiedOn: new Date(),

            guestId: userDetails.id,
            guestName: userDetails.firstName,

            membershipName: membership.name,
            membershipPlanId: membership.id,
            membershipFee: membership.membershipFee,
            purchaseAmount: (membership.membershipFee + (membership.isInclusive ? 0 : taxesTotal)),

            fromDate: new Date(),
            toDate,

            staffId: userDetails.staff?.id,
            storeId: storeData.storeId,
            tenantId: storeData.tenantId,

            txchrgs: txchrgs,
            payments,

            typeId: membership.typeId,
            balanceMinutes: Number(membership.balanceHours || 0) * 60,
            benefitMinutes: 0,
            carryMinutes: 0,
            renewedFrom: 0,

            totalRedeemedAmount: 0,
            balancePaymentAmount:
                payments.find(p => p.name === 'Balance')?.payment || 0,

            terminatedOn: null,
            remark: sourceRemark,
            uniqueRecordIdentifier,
            businessDate: getDateObj().dateObj

        };
    };

    const buildPackageTxnObj = ({
        packageDetails,
        userDetails,
        selectedItems,
        payments,
        uniqueRecordIdentifier,
        sourceRemark = 'Package Purchase from PDP'
    }) => {
        const currentDate = new Date();
        const fromDate = currentDate;
        const someDate = new Date(currentDate);
        const toDate = new Date(someDate.setDate(someDate.getDate() + Number(packageDetails.validity)));

        // Map selected services and products into utilizedPackageItems
        let packageItems = [];
        [...selectedItems.service, ...selectedItems.product].map((item) => {
            packageItems.push({
                "itemId": item.id,
                "itemName": item.name,
                "itemPrice": item.price,
                "categoryId": item.categoryId,
                "category": item.category,
                "quantity": item.quantity,
                "type": item.type,
                "variationId": item.variationId,
                "balanceQuantity": Number(item.quantity),
                "utilizedQuantity": 0,
                "packageId": packageDetails.id,
                "packagesTypeId": packageDetails.packagesTypeId,
                "hsnSac": item.hsnSac
            });
        });

        let txnObj: any = {
            "active": true,
            "createdBy": 0, // Online purchase
            "createdOn": currentDate,
            "guestId": userDetails.id,
            "staffId": 0,
            "paymode": payments[0]?.name || 'RAZORPAY',
            "remark": sourceRemark,
            "guestName": userDetails.firstName,
            "guestNumber": userDetails.mobileNo,
            "packageId": packageDetails.id,
            "packagesTypeId": packageDetails.packagesTypeId,
            "packageName": packageDetails.name,
            "modifiedBy": 0,
            "modifiedOn": currentDate,
            "fromDate": fromDate,
            "toDate": toDate,
            "storeId": storeData.storeId,
            "tenantId": storeData.tenantId,
            "billingPrice": Number(packageDetails.price || 0),
            "purchaseAmount": Number(packageDetails.price) + (getTaxesForTotal() || 0),
            "payments": payments,
            "hsnSac": packageDetails.hsnSac,
            "utilizedPackageItems": packageItems,
            "txchrgs": txchrgs || [],
            "reminderBeforeDay": packageDetails.reminderBeforeDay || 0,
            "uniqueRecordIdentifier": uniqueRecordIdentifier,
            "businessDate": getDateObj().dateObj
        };

        // Handle Quantified Custom Packages (Type 2)
        if (packageDetails.packagesTypeId === 2) {
            txnObj = {
                ...txnObj,
                "availableItemsQuantity": Number(packageDetails.itemsBaseQuantity),
                "totalItemsQuantity": Number(packageDetails.itemsBaseQuantity),
                "utilizedItemsQuantity": 0,
                "quantifiedCustomPackage": true,
            };
        }

        return txnObj;
    };

    const calculateTaxes = (packageData: any) => {
        let totalTax = 0;
        let processedTaxes: any[] = [];

        if (Array.isArray(item.txchrgs) && item.txchrgs.length !== 0) {
            processedTaxes = item.txchrgs.map((tax: any) => {
                const { id, ...rest } = tax;

                if (item.membershipFee) {
                    totalTax += Number(rest.value || 0);
                }

                return rest;
            });
        }

        setTaxesTotal(totalTax);
        setTxchrgs(processedTaxes);
    }


    const closePdpModal = () => {
        document.body.classList.remove("o-h")
        setTaxesTotal(0);
        setTxchrgs([]);
        setSelectedItems([])
        onClose()
    }

    const buildGiftCardTxnObj = ({
        cardDetails,
        userDetails,
        payments,
        uniqueRecordIdentifier,
        sourceRemark = 'Gift Card Purchase'
    }) => {
        const fromDate = new Date(cardDetails.fromDate || new Date());

        const toDate = new Date(fromDate);
        toDate.setDate(toDate.getDate() + Number(cardDetails.validity));
        return {
            active: true,
            balanceAmount: cardDetails.giftCardValue,
            createdOn: new Date(),
            modifiedOn: new Date(),
            fromDate: fromDate,
            toDate: toDate,
            giftCardId: cardDetails.id,
            giftCardName: cardDetails.name,
            giftCardValue: cardDetails.giftCardValue,
            purchaseAmount: cardDetails.giftCardValue, // Add taxes here if applicable
            guestId: userDetails?.id,
            guestName: userDetails?.firstName,
            guestMobNo: userDetails?.mobileNo,
            guestEmail: userDetails?.email,
            storeId: storeData.storeId,
            tenantId: storeData.tenantId,
            usedAmount: 0,
            payments: payments,
            guestGiftCardTaxes: [],
            remark: cardDetails.remark || sourceRemark,
            uniqueRecordIdentifier: uniqueRecordIdentifier,
            reminderBeforeDay: cardDetails?.reminderBeforeDay,
            businessDate: getDateObj().dateObj
        };
    };


    const onLoginClose = (user) => {
        if (user) {
            setUserData(user);
        }
        setShowUserRegistrationModal(false);
    }

    const onOutsideClick = (event: any) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            closePdpModal();
        }
    }

    const proceedToPayments = (mode: string = '') => {
        if ((paymentGatewayList?.length) > 1) {
            setOpenPaymentVendorModal(mode)
        } else {
            handlePaymentVendorSelection(paymentGatewayList[0])
        }
    }

    const handlePaymentVendorSelection = (paymode) => {
        if (paymode) {
            processPayment(paymode.name)
        }
        setOpenPaymentVendorModal('');
    }

    const getTaxesForTotal = () => {
        let total = 0;
        if (Boolean(txchrgs?.length)) {
            if (txchrgs[0].isInclusive) total = 0;
            else {
                total = txchrgs.reduce((a: any, b: any) => a + Number(b.value), 0);
            }
        }
        return (total)
    }


    const processPayment = (paymode) => {
        if (!userData) {
            setShowUserRegistrationModal(true);
            return;
        }
        const type = isMembership ? "Membership" : isPackage ? "Package" : "GiftCard";
        const labelName = isMembership ? "Membership" : isPackage ? "Package" : "Gift Card";
        const basePrice = isMembership ? item.membershipFee : isPackage ? item.price : item.giftCardValue;
        const totalPayment = Number(basePrice) + (getTaxesForTotal() || 0);
        const errorMsg = `${labelName} Purchase Failed`;

        const payments = [{
            "name": paymode,
            "payment": totalPayment,
            "createdOn": new Date().toISOString(),
            "txnId": "",
            "bankTxnId": 0,
            "cardNo": "",
            "remark": "Online Payment"
        }];
        const txnObj = isMembership
            ? buildMembershipTxnObj({ membership: item, userDetails: userData, payments, uniqueRecordIdentifier })
            : isPackage
                ? buildPackageTxnObj({ packageDetails: item, userDetails: userData, selectedItems, payments, uniqueRecordIdentifier })
                : buildGiftCardTxnObj({ cardDetails: item, userDetails: userData, payments, uniqueRecordIdentifier });

        dispatch(enableLoader());
        switch (paymode.toLowerCase()) {
            case "stripe":
                APISERVICE.POST(`${process.env.NEXT_PUBLIC_GUEST}/stripe/guest${type}`, txnObj)
                    .then((res: any) => {
                        const paymentAddress: any = {
                            area: storeMetaData.area,
                            city: storeMetaData.city,
                            country: storeMetaData.code,
                            code: storeMetaData.pincode,
                            line: storeMetaData.address,
                        };

                        setStripeModalDetails({
                            ...stripeModalDetails,
                            options: { ...stripeModalDetails.options, clientSecret: res.data.clientSecret },
                            paymentIntentId: res.data.paymentIntentId,
                            order: txnObj,
                            address: paymentAddress,
                            user: userData,
                            callbackUrl: res.data.callbackUrl
                        });
                        dispatch(disableLoader());
                    })
                    .catch((error) => {
                        console.error(error);
                        dispatch(disableLoader());
                        dispatch(showError(languageData[errorMsg] || errorMsg));
                    });
                break;

            case "razorpay":
                APISERVICE.POST(`${process.env.NEXT_PUBLIC_GUEST}/rzr/guest${type}`, txnObj)
                    .then((res) => {
                        setTimeout(() => {
                            const { Razorpay }: any = window;
                            const razorOptions = res.data;
                            delete razorOptions.payment_link_id;
                            const rzp1 = new Razorpay(razorOptions);
                            rzp1.open();
                            dispatch(disableLoader());
                        }, 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        dispatch(disableLoader());
                        dispatch(showError(languageData[errorMsg] || errorMsg));
                    });
                break;

            case "paystack":
                APISERVICE.POST(`${process.env.NEXT_PUBLIC_GUEST}/paystack/guest${type}`, txnObj)
                    .then((res) => {
                        const response = res.data;
                        const { PaystackPop }: any = window;

                        const paystackOptions = {
                            key: response.publicKey,
                            email: response.email,
                            amount: response.amount,
                            ref: response.reference,
                            currency: "NGN",
                            callback: function (paymentResponse) {
                                APISERVICE.POST(`${process.env.NEXT_PUBLIC_GUEST}/paystack/verify${type}`, { reference: paymentResponse.reference })
                                    .then((verifyRes) => {
                                        dispatch(showSuccess(`${labelName} purchased successfully`));
                                        window.location.href = verifyRes.data.redirectUrl;
                                    })
                                    .catch(() => {
                                        dispatch(showError("Payment verification failed"));
                                    });
                            },
                            onClose: function () {
                                dispatch(showError("Payment cancelled"));
                            }
                        };
                        const handler = PaystackPop.setup(paystackOptions);
                        handler.openIframe();
                        dispatch(disableLoader());
                    })
                    .catch((error) => {
                        console.error(error);
                        dispatch(disableLoader());
                        dispatch(showError(languageData[errorMsg] || errorMsg));
                    });
                break;

            case "globalpayments":
                APISERVICE.POST(`${process.env.NEXT_PUBLIC_GUEST}/globalpayments/guest${type}`, txnObj)
                    .then((res: any) => {
                        setGlobalPaymentsModalDetails({
                            accessToken: res.data.accessToken,
                            reference: res.data.reference
                        });
                        dispatch(disableLoader());
                        setTimeout(() => {
                            const { GlobalPayments }: any = window;
                            if (!GlobalPayments) {
                                console.error("Global Payments SDK script is missing from window context.");
                                return;
                            }
                            GlobalPayments.configure({
                                accessToken: res.data.accessToken,
                                apiVersion: "2021-03-22",
                                env: process.env.NEXT_PUBLIC_ENVIRONMENT === "production" ? "production" : "sandbox"
                            });

                            const cardForm = GlobalPayments.creditCard.form("#global-payments-container", {
                                style: "gp-default"
                            });
                            cardForm.ready(() => {
                            });
                            cardForm.on("token-success", (tokenResponse: any) => {
                                dispatch(enableLoader());
                                const extractedToken = tokenResponse.paymentReference;
                                APISERVICE.POST(`${process.env.NEXT_PUBLIC_GUEST}/globalpayments/verify${type}`, {
                                    reference: res.data.reference,
                                    paymentToken: extractedToken
                                })
                                    .then((verifyRes) => {
                                        dispatch(showSuccess(`${labelName} purchased successfully`));
                                        window.location.href = verifyRes.data.redirectUrl;
                                    })
                                    .catch(() => {
                                        dispatch(disableLoader());
                                        dispatch(showError("Payment verification failed"));
                                    });
                            });

                            cardForm.on("token-error", (error: any) => {
                                console.error("Global Payments UI validation error captured: ", error);
                                let errMsg = "Card validation failed";
                                if (error.message) errMsg = error.message;
                                else if (error.details && error.details.length > 0) {
                                    errMsg = `${error.details[0].field.replace("card-", "").toUpperCase()}: ${error.details[0].message}`;
                                }

                                dispatch(disableLoader());
                                dispatch(showError(errMsg));
                            });
                        }, 100);
                    })
                    .catch((error) => {
                        console.error(error);
                        dispatch(disableLoader());
                        dispatch(showError(languageData[errorMsg] || errorMsg));
                    });
                break;
            default:
                dispatch(disableLoader());
                break;
        }
    };

    return (
        <>
            {hasPaymentGateway("razorpay", paymentGatewayList) && (<Script src="https://checkout.razorpay.com/v1/checkout.js" strategy="lazyOnload" />)}
            {hasPaymentGateway("paystack", paymentGatewayList) && (<Script src="https://js.paystack.co/v1/inline.js" strategy="lazyOnload" />)}
            {hasPaymentGateway("globalpayments", paymentGatewayList) && (<Script src="https://js.globalpay.com/4.1.21/globalpayments.js" strategy="lazyOnload" />)}
            
            <div
                className="membership-modal-overlay"
                onClick={onOutsideClick}
                style={{
                    display: (item && item.name) ? 'flex' : 'none',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    position: 'fixed',
                    inset: 0,
                    zIndex: 10,
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                {Boolean(item) &&
                    <div className="membership-checkout-content">
                        <div className="checkout-header">
                            <div className="title">{isMembership ? "Membership " : isPackage ? "Package " : "Gift Card "}Details</div>
                            <div className="close-icon" onClick={closePdpModal}>
                                <IconFrame><CloseIcon /></IconFrame>
                            </div>
                        </div>
                        <div className="modal-scroll-area">
                            <div className="checkout-card">
                                <div className="sub-heading">{isGiftCard ? "Card" : "Plan"} Name</div>
                                <div className="main-value">{item.name}</div>
                            </div>

                            {item.description && (
                                <div className="checkout-card">
                                    <div className="sub-heading">Description</div>
                                    <div className="description-text">{item.description}</div>
                                </div>
                            )}

                            <div className="checkout-card">
                                {isMembership && <div className="sub-heading">Benefits</div>}
                                {isMembership && item.typeId == FIXED_MEMBERSHIP && <div className="info-row">
                                    <div className="label">Benefit Amount</div>
                                    <div className="value">{getCurrencySymbol()}{item.benefit}</div>
                                </div>}
                                {isMembership && Boolean(!item.isSpecificDays) && (item.typeId == PERCENTAGE_MEMBERSHIP || item.typeId == HYBRID_MEMBERSHIP) && <div className="info-row">
                                    <div className="label">Std Discount:</div>
                                    <div className="value">{item.discount}%</div>
                                </div>}
                                {isMembership && item.typeId == HOURLY_MEMBERSHIP && <div className="info-row">
                                    <div className="label">Hours</div>
                                    <div className="value">{(item.totalMinutes / 60)} hrs</div>
                                </div>}
                                {item.isSharable && (
                                    <div className="info-row">
                                        <div className="label">Sharing Capacity</div>
                                        <div className="value">{item.sharableCount} Members</div>
                                    </div>
                                )}
                                <div className="info-row">
                                    <div className="sub-heading">Validity</div>
                                    <div className="value">{item.validity} Days</div>
                                </div>
                            </div>
                            {isPackage && Boolean(item?.packageItems?.length) && (
                                <div className="checkout-card">
                                    {item.packageItems.some(pkg => pkg.type === "service") && (
                                        <>
                                            <div className="sub-heading">Services</div>
                                            {item.packageItems.filter(pkg => pkg.type === "service")
                                                .map((pkgItem, index) => (
                                                    <div className="info-row" key={index}>
                                                        <div className="label">{pkgItem.itemName}</div>
                                                        <div className="value">{pkgItem.quantity}</div>
                                                    </div>
                                                ))}
                                        </>
                                    )}
                                    {item.packageItems.some(pkg => pkg.type === "product") && (
                                        <>
                                            <div className="sub-heading">Products</div>
                                            {item.packageItems.filter(pkg => pkg.type === "product")
                                                .map((pkgItem, index) => (
                                                    <div className="info-row" key={index}>
                                                        <div className="label">{pkgItem.itemName}</div>
                                                        <div className="value">{pkgItem.quantity}</div>
                                                    </div>
                                                ))}
                                        </>
                                    )}

                                </div>
                            )}

                            <div className="checkout-card pricing-card">
                                <div className="sub-heading">{languageData["RedeemablePricing Details"] ? languageData["RedeemablePricing Details"] : "Pricing Details"}</div>
                                <div className="pricing-details-wrap">
                                    <div className="pricing-row">
                                        <div className="title">{isGiftCard ? "Card" : "Plan"} Fee</div>
                                        <div className="value">{configData.currencySymbol} {displayPrice}</div>
                                    </div>
                                    {txchrgs?.length != 0 && <div className="sub-heading">Tax Details</div>}
                                    {txchrgs?.length != 0 && <div className={`taxes-list ${(Number(txchrgs?.length) ? true : false) ? "" : "disabled"}`}>
                                        {txchrgs?.map((taxDetails: any, i: any) => {
                                            return <div className='pricing-row' key={i}>
                                                <div className="title">{taxDetails.name} ({taxDetails.taxRate}{taxDetails.type == "PERCENTAGE" ? '%' : getCurrencySymbol()})
                                                    {Boolean(taxDetails.isInclusive) && <>(Inclusive)</>}
                                                    :</div>
                                                <div className="value">{getCurrencySymbol()} {(taxDetails.value)}</div>
                                            </div>
                                        })}
                                    </div>}
                                    <div className="pricing-row total-row">
                                        <div className="title">Grand Total</div>
                                        <div className="value">{configData.currencySymbol} {displayPrice + (getTaxesForTotal() || 0)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {!configData?.storeOff && allowPurchase && (
                            <div className="confirm-btn-wrap">
                                <div className="primary-btn" onClick={() => proceedToPayments('fullpayment')} >
                                    Pay Now
                                </div>
                            </div>
                        )}
                    </div>
                }
            </div>

            {showUserRegistrationModal && <UserRegistrationModal
                fromPage={'PDP'}
                handleResponse={(e) => onLoginClose(e)}
                isApppGrpChangeOnUserGdrChange={showUserRegistrationModal ? true : false}
                open={true}
                heading={'Login to purchase membership'} />}

            <PaymentVendorModal
                open={Boolean(openPaymentVendorModal)}
                handleClose={(e: any) => handlePaymentVendorSelection(e)}
                paymentGatewayList={paymentGatewayList}
            />

            <StripePaymentModal
                stripeModalDetails={stripeModalDetails}
                setStripeModalDetails={setStripeModalDetails}
                title={languageData["Pay Here"] ? languageData["Pay Here"] : "Pay Here"}
            />

            {globalPaymentsModalDetails.accessToken ? (
                <Backdrop className="backdrop-modal-wrapper" open={!!globalPaymentsModalDetails.accessToken}>
                    <div className="backdrop-modal-content globalpayments-modal-content">
                        <div className="modal-close" onClick={() => setGlobalPaymentsModalDetails({ accessToken: "", reference: "" })}>
                            <IconFrame><CloseIcon /></IconFrame>
                        </div>
                        <div className="heading">{languageData["Pay Here"] ? languageData["Pay Here"] : "Pay Here"}</div>
                        <div id="global-payments-container" style={{ padding: '16px 8px' }}></div>
                    </div>
                </Backdrop>
            ) : null}
        </>

    );
}

export default RedeemableItemModal;